var projectGroups = {

    listen: function () {
        // Only initialize if the form exists (for admin users)
        let form = $("form#ProjectGroupUpdateForm");
        if (form.length && $('#customer-select-wrapper').length) {
            // If we have a project group parent set, disable the customer. They get inferred from the parent.
            projectGroups.toggleCustomerField();

            // Same as above but if we change
            form.find('#parent_id').on('change', function() {
                projectGroups.toggleCustomerField();
            });
        }
    },

    /**
     * If you pick a project group parent, we need to hide the customer id select2 
     * and we want to show a note just saying it'll be inferred from the parent.
     */
    toggleCustomerField: function() {
        let form = $("form#ProjectGroupUpdateForm");
        let customerSelectWrapper = $('#customer-select-wrapper');
        let customerNote = $('#customer-note');
        
        // Only admin users actually have this field (customer is inferred otherwise)
        if (form.length && customerSelectWrapper.length && customerNote.length) {
            let parentSelected = form.find('#parent_id').val();
            
            if (parentSelected && parentSelected !== '') {
                customerSelectWrapper.hide();
                customerNote.show();
            } else {
                customerSelectWrapper.show();
                customerNote.hide();
            }
        }
    }

}

$(function () {
    projectGroups.listen()
});

module.exports = {
    projectGroups
};